module.exports = __webpack_public_path__ + "static/parade-2019-house13-2c5b01365a2c583af54c4776a7934b45.jpg";